export default {"src":"/_next/static/media/handshake.9742b02e.svg","height":24,"width":24};